import React from 'react'

import { AnalyzeSettings } from '@/containers/Analyze'

export const SettingsAnalyze = () => {
    return <AnalyzeSettings />
}
